import {
  Avatar,
  Box,
  TagColor as Color,
  List,
  Tag,
  Text,
} from '@factorialco/deprecated-design-system'
import {
  ProjectManagementProjectRoleRoleEnum,
  ProjectRolesQuery,
} from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

export interface RoleRowProps {
  editable: boolean
  role: ProjectManagementProjectRoleRoleEnum
  roleId: number
  employeeName: string
  employee: ProjectRolesQuery['projectManagement']['projectRoles'][number]['employee']
  onUpdateRow: (projectRoleId: number, role: ProjectManagementProjectRoleRoleEnum) => void
  onDeleteRow: (projectId: number) => void
  canAssignOwners: boolean
  canAssignEditors: boolean
}

const RoleRow = ({
  editable,
  role,
  roleId,
  employeeName,
  employee,
  onUpdateRow,
  onDeleteRow,
  canAssignOwners,
  canAssignEditors,
}: RoleRowProps) => {
  const getLabel = (): string => {
    switch (role) {
      case 'owner':
        return i18n.t('project_management.roles.owner.title')
      case 'editor':
        return i18n.t('project_management.roles.editor.title')
      case 'viewer':
        return i18n.t('project_management.roles.viewer.title')
      default:
        return ''
    }
  }

  const onUpdate = (newRole: ProjectManagementProjectRoleRoleEnum) => {
    onUpdateRow(roleId, newRole)
  }

  const canEdit =
    editable && ((canAssignEditors && (role === 'editor' || role === 'viewer')) || canAssignOwners)

  if (!employee) {
    return null
  }

  return (
    <List.Item key={roleId}>
      <Box flexDirection="row" justifyContent="spaceBetween" width="full">
        <Box flexDirection="row">
          <Avatar size="s24" url={buildUrl(employee.access.avatar)} label={employee.fullName} />
          <Box paddingLeft="s24">
            <Text.Normal weight="medium">{employeeName}</Text.Normal>
          </Box>
        </Box>
        {canEdit ? (
          <PopoverMenu type="list">
            <PopoverMenu.Trigger>
              <Tag rightItem="dropdown" inline showActionIcon type={Color.malibu}>
                {getLabel()}
              </Tag>
            </PopoverMenu.Trigger>
            <PopoverMenu.Content side="bottom" align="end">
              {canAssignOwners && (
                <PopoverMenu.TouchableOption
                  onClick={() => {
                    onUpdate('owner')
                  }}
                  title={i18n.t('project_management.roles.owner.title')}
                  description={i18n.t('project_management.roles.owner.description')}
                />
              )}
              <PopoverMenu.TouchableOption
                onClick={() => {
                  onUpdate('editor')
                }}
                title={i18n.t('project_management.roles.editor.title')}
                description={i18n.t('project_management.roles.editor.description')}
              />
              <PopoverMenu.TouchableOption
                onClick={() => {
                  onUpdate('viewer')
                }}
                title={i18n.t('project_management.roles.viewer.title')}
                description={i18n.t('project_management.roles.viewer.description')}
              />
              <PopoverMenu.TouchableOption
                onClick={() => {
                  onDeleteRow(roleId)
                }}
                title={i18n.t('common.remove')}
                danger
              />
            </PopoverMenu.Content>
          </PopoverMenu>
        ) : (
          <Box justifyContent="center">
            <Tag inline type={Color.malibu}>
              {getLabel()}
            </Tag>
          </Box>
        )}
      </Box>
    </List.Item>
  )
}

export default RoleRow
